
define('text!views/howto/howto.html',[],function () { return '<div class="howto-content">\r\n\t\t\t\r\n\t<h1>How To:</h1>\r\n\r\n\t<div class="js-how-to-videos"></div>\r\n\r\n</div>';});

